import Image from '@/components/image';
import useOnClickOutside from '@/hooks/useOnClickOutside';
import { event_button_click, event_installment_option } from '@/utils/gtm';
import { useEffect, useRef, useState } from 'react';
import InstallmentText from './InstallmentText';
import TamaraModal from './tamara-modal';

const TamaraWidget = ({ locale, amount, buttonLocation }) => {
  const [show, setShow] = useState(false);
  const refModel = useRef();
  const refBtn = useRef();

  useOnClickOutside([refModel, refBtn], () => setShow(false));

  useEffect(() => {
    if (show) {
      event_installment_option({ merchant_name: 'tamara' });
      event_button_click({
        button_name: 'Tamara',
        button_destination: 'open_bnpl_info',
        button_location: buttonLocation,
      });
    }
  }, [show, buttonLocation]);

  return (
    <div
      ref={refBtn}
      onClick={() => setShow((show) => !show)}
      className='border-border flex min-h-[55px] items-center rounded-md border bg-white px-1'
    >
      <Image
        src={`/imgs/payments/tamara_pay_by_instalments.png`}
        className='h-7 w-[85px] object-contain'
        alt='tamara img!'
        width={85}
        height={28}
      />
      <InstallmentText
        {...{
          locale,
          payNum: 12,
          mainPrice: Math.round(amount / 12) || '',
          onClick: () => null,
        }}
      />
      {show ? <TamaraModal {...{ locale, setShow, amount, show }} /> : null}
    </div>
  );
};
export default TamaraWidget;
